
import {Phonemes} from "./phonemes.js"

// inspired by urbit's @p naming system
export const suffixes = new Phonemes([
	"nop", "ryx", "rux", "rak", "ruk", "rad", "ren", "ryd", "zex", "zyx", "zok", "bob", "zud", "zen", "zyn", "lax",
	"nox", "max", "dax", "rax", "kex", "ken", "kyn", "kor", "kur", "kad", "ker", "ked", "kaz", "kez", "lek", "lex",
	"lyx", "lur", "lan", "len", "lod", "lum", "myn", "myr", "mox", "mux", "mak", "med", "nek", "nyx", "nor", "nex",
	"nux", "nod", "nur", "pak", "pex", "pyr", "pyx", "rex", "sak", "syd", "syr", "tek", "tyx", "tux", "tor", "tur",
	"vek", "vex", "vyr", "vox", "wex", "wyn", "wyr", "wux", "nyl", "yex", "yod", "yux", "zor", "zyl", "wok", "bex",
	"bry", "bur", "car", "coy", "cry", "cur", "dar", "dex", "dyr", "dur", "far", "fex", "fyr", "fur", "gar", "gex",
	"gyr", "gur", "har", "hex", "het", "hur", "jox", "jex", "ray", "rey", "kar", "kyr", "lar", "lyr", "mar", "mex",
	"mur", "nar", "par", "pur", "rar", "raz", "roy", "sar", "sur", "tar", "tex", "tyr", "var", "vur", "war", "wur",
	"yar", "yer", "yur", "zar", "zop", "zur", "bak", "bok", "buk", "dak", "dek", "dok", "duk", "fek", "fok", "gak",
	"gek", "gok", "hak", "hek", "hok", "koy", "key", "kay", "kak", "kek", "kel", "lak", "lok", "mek", "mok", "nak",
	"nok", "pek", "pok", "rek", "rok", "sek", "sok", "tak", "tok", "vak", "vok", "wak", "wek", "yak", "yek", "yok",
	"vyk", "vyx", "wyk", "wyx", "mer", "yax", "mac", "bek", "bax", "hax", "dox", "fox", "fyx", "gyn", "gyx", "hon",
	"hop", "jan", "jeb", "kan", "kog", "lyk", "myk", "myx", "nyk", "pyk", "ryk", "syk", "syx", "tyk", "vod", "wyd",
	"dyd", "zan", "zer", "yen", "yew", "zyd", "byd", "byr", "dyb", "fyd", "gyd", "hen", "red", "lyd", "myd", "daz",
	"nyd", "pyd", "tyd", "vyn", "zek", "byn", "dyn", "fyn", "gen", "lyn", "nyn", "ryn", "syn", "tyn", "myl", "bef",
	"lyt", "wyz", "wuk", "kax", "sax", "kew", "wen", "ryt", "tyv", "kon", "ryz", "zad", "tyz", "vuz", "ron", "rez",
])

